var map = {
	"./implantbook.png": 6907,
	"./inews.png": 6309,
	"./inewsidem.png": 4501,
	"./inewsids.png": 820,
	"./infodent.png": 7496,
	"./infomedix.png": 812,
	"./tabloid.png": 9208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9036;